import { Component, inject } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget
} from '@eforall/dashboard';
import { ToolbarWidget } from '../../../ui/widget';
import { FinanceCostPageService } from './finance-cost.page.service';
import { FinanceCostTab1Part } from './tabs/tab-1/finance-cost-tab-1.part';
import { FinanceCostTab2Part } from './tabs/tab-2/finance-cost-tab-2.part';
import { FinanceCostViewsPart } from './views/finance-cost-views.part';


@Component({
	selector: 'finance-cost-page',
	standalone: true,
	imports: [
		FinanceCostTab1Part, FinanceCostTab2Part, FinanceCostViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		ToolbarWidget,
		PageTabsWidget],
	templateUrl: './finance-cost.page.html',
})
export class FinanceCostPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public pageService = inject(FinanceCostPageService);

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}